<template>
	<modal name="login-modal" width="100%" height="auto" :click-to-close="false">
		<div class="p-3">
			<div class="text-center mt-3">
				<h5 id="modal-headline">
					{{ $t("Would you like to connect to an account to save your details and order history for next time?") }}"
				</h5>

				<div class="form-signin mt-5">
					<a :href="getUrlFor('google')" class="btn btn-lg btn-google btn-block text-uppercase mb-3">
						<i class="fab fa-google mr-2" aria-hidden="true"></i>
						{{ $t("Sign in with Google") }}
					</a>

					<a :href="getUrlFor('facebook')" class="btn btn-lg btn-facebook btn-block text-uppercase mb-3">
						<i class="fab fa-facebook-f mr-2" aria-hidden="true"></i>
						{{ $t("Sign in with Facebook") }}
					</a>

					<a :href="getUrlFor('apple')" class="btn btn-lg btn-apple btn-block text-uppercase">
						<i class="fab fa-apple mr-2" aria-hidden="true"></i>
						{{ $t("Sign In With Apple") }}
					</a>
				</div>
			</div>
		</div>

		<hr />

		<div class="text-center border-solid mt-4 py-0 px-3 mb-4">
			<button class="btn btn-primary mr-2" v-on:click="$modal.hide('login-modal')">
				{{ $t("Continue as guest") }}
			</button>
		</div>
	</modal>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	methods: {
		getUrlFor(service) {
			return `${window.app.oauth_proxy_domain}/redirect/${service}/${window.app.company_subdomain}/${window.app.last_site}`;
		}
	}
});
</script>
